export default {"src":"/_next/static/media/start_outiline.e3fbce8f.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};